var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConditionDocumentLawSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#575757",
    width: "64px",
    height: "64px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#575757",
    strokeWidth: 2.304,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Terms and Condition",
    id: "Terms_and_Condition"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.5,16h-33A8.51,8.51,0,0,0,27,24.5V62H24.5a8.5,8.5,0,0,0,0,17h36A8.51,8.51,0,0,0,69,70.5v-54A.5.5,0,0,0,68.5,16ZM28,24.5A7.5,7.5,0,0,1,35.5,17H68V62H28ZM24.5,78a7.5,7.5,0,0,1,0-15h32a8.49,8.49,0,0,0,0,15ZM68,70.5A7.5,7.5,0,1,1,60.5,63H68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,32a.51.51,0,0,0-.39-.49l-7.5-1.76a.41.41,0,0,0-.22,0l-7.5,1.76A.51.51,0,0,0,40,32v8a9.32,9.32,0,0,0,4.77,8.14l3,1.89a.5.5,0,0,0,.51,0l3.35-1.82,0,0A9.27,9.27,0,0,0,56,40.35Zm-1,8.35a8.29,8.29,0,0,1-3.9,7L48,49.07l-2.74-1.75A8.34,8.34,0,0,1,41,40V32.4l7-1.65,7,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,25h27a.5.5,0,0,0,0-1h-27a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,54.5a.5.5,0,0,0-.5-.5h-27a.5.5,0,0,0,0,1h27A.5.5,0,0,0,62,54.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,30h-4a.5.5,0,0,0,0,1h4a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,36h-3a.5.5,0,0,0,0,1h3a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,42h-3a.5.5,0,0,0,0,1h3a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5,49h7a.5.5,0,0,0,0-1h-7a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,31h4a.5.5,0,0,0,0-1h-4a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,37h3a.5.5,0,0,0,0-1h-3a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,43h3a.5.5,0,0,0,0-1h-3a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,49h7a.5.5,0,0,0,0-1h-7a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4,38.29a.51.51,0,0,0-.7-.1.5.5,0,0,0-.1.7L46,42.07h0s0,0,0,0l.1.08s0,0,.06,0a.42.42,0,0,0,.22.05.46.46,0,0,0,.27-.09h.05l5.57-4.77a.5.5,0,1,0-.65-.76l-5.16,4.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionDocumentLawSvgrepoCom);
export default __webpack_public_path__ + "static/media/condition-document-law-svgrepo-com.2cce556d485d0c47f6453191acee407b.svg";
export { ForwardRef as ReactComponent };